import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowRight from '@material-ui/icons/ArrowRightAlt'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useNavigate } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import $ from "jquery";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {

        marginLeft: 240,
    },
    drawer: {
        width: '100%',
        flexShrink: 0,
    },
    drawerPaper: {
        width: 100,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        boxShadow: "none !important",
        border: "1px solid #F1F1F1",

    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
    },
    leftCount: {
        height: "24px !important",
        background: "#E2E2E2",
        boxShadow: "0px 1px 18px rgb(0 0 0 / 4%)",
        padding: "6px",
        paddingTop: "4px",
        maxWidth: "25px"
    },
}));

const SideBar = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [isMobile, setisMobile] = React.useState();
    const [value, setValue] = React.useState(0);
    const [more, setMore] = React.useState(false);
    const [less, setLess] = React.useState(false);
    const [plan, setPlan] = React.useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        window.addEventListener('resize', resize);
        const interval = setInterval(() => {
            resize()
          }, 100);
          return () => clearInterval(interval);
    }, []);

    const resize = () => {
        if (window.innerWidth < 850) { setisMobile(true) }
        else { setisMobile(false) }
        $("#Operations1 .MuiListItemText-primary").removeClass("fw-bolder");
        $("#Operations1 .MuiListItemText-primary").addClass("spanTopBar");
    };

    const DailyNavigation = (str, path) => {
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("spanTopBar");
        navigate(path);
    }
    return (<>
        {isMobile ?
            <div className={classes.root}>
                <CssBaseline />

                {/* <Drawer
             className={classes.drawer}
             variant="permanent"
             classes={{
                 paper: classes.drawerPaper,
             }}
             anchor="left"
         > */}

                {/* <List>
                 {['Ship Particulars', 'Project Status Tracker', 'Beaching Documents', 'Pre-cutting Progress', 'Drill Plan & Actual', 'Block Tracking', 'Ship Particulars', 'Disposal record of hazard', 'Beaching Documents', 'Training Module', 'Drill Plan & Actual', 'Block Tracking'].map((text, index) => (
                     <ListItem button key={text}>
                         <ListItemText primary={text} />
                         {text === "Project Status Tracker" ?
                             <ListItemIcon>{<ArrowRight />}</ListItemIcon> : null}
                     </ListItem>
                 ))}
             </List>
             <Divider />
             <List>
                 {['Disposal record of hazard', 'Matrix of Materials - Hazardous', 'Matrix of Materials - Disposition'].map((text, index) => (
                     <ListItem button key={text}>
                         <ListItemText primary={text} />
                     </ListItem>
                 ))}
             </List> */}

                {(<>

                    <List className="pt-4 mt-5 w-100" style={{ overflowY: 'scroll', height: "100%", marginTop: "80px", bottom: '0', backgroundColor: "#F6F6F6" }}>
                        <ListItem className='border-bottom' >
                            <ListItemText id={"Operations" + "1"} className='pl-3 textNaviIcon' primary="Daily Tasks" />
                            <NavigateBeforeIcon id="Operations" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>

                        <ListItem button onClick={() => DailyNavigation("Operation", "/operationplanningachievements")}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>01  &nbsp;</Typography>
                            <ListItemText id={"Operation" + "1"} className='pl-3 textNaviIcon' primary="Operation Planning & Acheivement" />
                            <NavigateNextIcon id="Operation" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => DailyNavigation("Prebeaching", "/prebeachingdocuments")} >
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>02  &nbsp;</Typography>
                            <ListItemText id={"Prebeaching" + "1"} className='pl-3 textNaviIcon' primary="Pre-Beaching Documents" />
                            <NavigateNextIcon id="Prebeaching" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => DailyNavigation("Precutting", "/precuttingprogressreport")} >
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>03  &nbsp;</Typography>
                            <ListItemText id={"Precutting" + "1"} className='pl-3 textNaviIcon' primary="Pre Cutting Progress" />
                            <NavigateNextIcon id="Precutting" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => DailyNavigation("DailyWork", "/dailyworkprogressreport")} >
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>04  &nbsp;</Typography>
                            <ListItemText id={"DailyWork" + "1"} className='pl-3 textNaviIcon' primary="Daily Work Progress" />
                            <NavigateNextIcon id="DailyWork" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => DailyNavigation("Workpermits", "/workpermits")} >
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>05  &nbsp;</Typography>
                            <ListItemText id={"Workpermits" + "1"} className='pl-3 textNaviIcon' primary="Work Permits" />
                            <NavigateNextIcon id="Workpermits" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        {/* <ListItem button onClick={() => DailyNavigation("TrainModule", "/trainingmodule")} >
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>06  &nbsp;</Typography>
                            <ListItemText id={"TrainModule" + "1"} className='pl-3 textNaviIcon' primary="Training Module" />
                            <NavigateNextIcon id="TrainModule" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem> */}
                        <ListItem button onClick={() => DailyNavigation("Trainingplan", "/trainingstatus")}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>06  &nbsp;</Typography>
                            <ListItemText id={"Trainingplan" + "1"} className='pl-3 textNaviIcon' primary="Training Status" />
                            <NavigateNextIcon id="Trainingplan" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => DailyNavigation("Drillplan", "/yarddrillplan")}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>07  &nbsp;</Typography>
                            <ListItemText id={"Drillplan" + "1"} className='pl-3 textNaviIcon' primary="Drill Plan" />
                            <NavigateNextIcon id="Drillplan" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => DailyNavigation("Dailyman", "/dailymanpowerstatus")}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>08  &nbsp;</Typography>
                            <ListItemText id={"Dailyman" + "1"} className='pl-3 textNaviIcon' primary="Daily Manpower Status" />
                            <NavigateNextIcon id="Dailyman" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => DailyNavigation("Investigation", "/investigationreports")}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>09  &nbsp;</Typography>
                            <ListItemText id={"Investigation" + "1"} className='pl-3 textNaviIcon' primary="Investigation Reports" />
                            <NavigateNextIcon id="Investigation" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => { setMore(!more) }}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>10  &nbsp;</Typography>
                            <ListItemText className='pl-3' primary="HSEQ Performance Indicator" />
                            <NavigateNextIcon className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            {more ? <ExpandMore /> : <ExpandLess />}
                            <Divider />
                        </ListItem>
                        {more ? "" : <>
                            <ListItem button onClick={() => DailyNavigation("Hseqkpi", "/hseq/kpi")} >
                                <Typography style={{ marginLeft: "15px" }} className={classes.leftCount + " " + "text-center mr-2"}>A  &nbsp;</Typography>
                                <ListItemText id={"Hseqkpi" + "1"} className='pl-3 textNaviIcon' primary="KPI" />
                                <NavigateNextIcon id="Hseqkpi" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                <Divider />
                            </ListItem>
                            <ListItem button onClick={() => DailyNavigation("Hseqper", "/hseq/performance")} >
                                <Typography style={{ marginLeft: "15px" }} className={classes.leftCount + " " + "text-center mr-2"}>B  &nbsp;</Typography>
                                <ListItemText id={"Hseqper" + "1"} className='pl-3 textNaviIcon' primary="HSEQ Performance" />
                                <NavigateNextIcon id="Hseqper" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                <Divider />
                            </ListItem></>}
                        <ListItem button onClick={() => DailyNavigation("Initial", "/initialauditdailyobservationstatus")}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>11  &nbsp;</Typography>
                            <ListItemText id={"Initial" + "1"} className='pl-3 textNaviIcon' primary="Initial Audit & Daily Observation Status" />
                            <NavigateNextIcon id="Initial" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => { setLess(!less) }} >
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>12  &nbsp;</Typography>
                            <ListItemText className='pl-3' primary="Dismantling Sequence" />
                            <NavigateNextIcon className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            {less ? <ExpandMore /> : <ExpandLess />}
                            <Divider />
                        </ListItem>
                        {less ? "" : <>
                            <ListItem button onClick={() => { setPlan(!plan) }}>
                                <Typography style={{ marginLeft: "15px" }} className={classes.leftCount + " " + "text-center mr-2"}>A  &nbsp;</Typography>
                                <ListItemText className='pl-3' primary="Dismantling Plan" />
                                <NavigateNextIcon className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                {plan ? <ExpandMore /> : <ExpandLess />}
                                <Divider />
                            </ListItem>
                            {plan ? "" : <>
                                <ListItem onClick={() => DailyNavigation("Disblockdiv", "/dismantlingplan/blockdivision")} button>
                                    <Typography style={{ marginLeft: "30px" }} className={classes.leftCount + " " + "text-center mr-2"}>&nbsp;I&nbsp;</Typography>
                                    <ListItemText id={"Disblockdiv" + "1"} className='pl-3 textNaviIcon' primary="Block Division" />
                                    <NavigateNextIcon id="Disblockdiv" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                    <Divider />
                                </ListItem>
                                <ListItem button onClick={() => DailyNavigation("Dissecdiv", "/dismantlingplan/sectiondivision")} >
                                    <Typography style={{ marginLeft: "30px" }} className={classes.leftCount + " " + "text-center mr-2"}>  II&nbsp;</Typography>
                                    <ListItemText id={"Dissecdiv" + "1"} className='pl-3 textNaviIcon' primary="Section Division" />
                                    <NavigateNextIcon id="Dissecdiv" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                    <Divider />
                                </ListItem>
                            </>}
                            <ListItem button onClick={() => DailyNavigation("Disweight", "/dismantlingweightcalculation")}>
                                <Typography style={{ marginLeft: "15px" }} className={classes.leftCount + " " + "text-center mr-2"}>B  &nbsp;</Typography>
                                <ListItemText id={"Disweight" + "1"} className='pl-3 textNaviIcon' primary="Dismantling Weight Calculation" />
                                <NavigateNextIcon id="Disweight" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                <Divider />
                            </ListItem>
                            <ListItem button onClick={() => DailyNavigation("Dispro", "/dismantlingprogress")}>
                                <Typography style={{ marginLeft: "15px" }} className={classes.leftCount + " " + "text-center mr-2"}>C  &nbsp;</Typography>
                                <ListItemText id={"Dispro" + "1"} className='pl-3 textNaviIcon' primary="Dismantling Progress" />
                                <NavigateNextIcon id="Dispro" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                                <Divider />
                            </ListItem></>}
                        <ListItem button onClick={() => DailyNavigation("Statement", "/statementofcompletion")}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>13  &nbsp;</Typography>
                            <ListItemText id={"Statement" + "1"} className='pl-3 textNaviIcon' primary="Statement of Completion" />
                            <NavigateNextIcon id="Statement" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => DailyNavigation("Disposition", "/dispositionrecordsofhazardousmaterials")}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>14  &nbsp;</Typography>
                            <ListItemText id={"Disposition" + "1"} className='pl-3 textNaviIcon' primary="Disposition Records of Hazardous Materials" />
                            <NavigateNextIcon id="Disposition" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => DailyNavigation("Matrix", "/matrixofmaterials")}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>15  &nbsp;</Typography>
                            <ListItemText id={"Matrix" + "1"} className='pl-3 textNaviIcon' primary="Matrix of Materials-Disposition" />
                            <NavigateNextIcon id="Matrix" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                        <ListItem button onClick={() => DailyNavigation("Carbonfootprint", "/carbonfootprintghgreductioncalculation")}>
                            <Typography className={classes.leftCount + " " + "text-center mr-2"}>15  &nbsp;</Typography>
                            <ListItemText id={"Carbonfootprint" + "1"} className='pl-3 textNaviIcon' primary="Carbon Foot print & GHG Reduction Calculation" />
                            <NavigateNextIcon id="Carbonfootprint" className="naviIcon d-none" style={{ width: 23, height: 23 }} />
                            <Divider />
                        </ListItem>
                    </List>
                </>)}
                {/* </Drawer> */}
            </div>
            :
            navigate('/operationplanningachievements')}
    </>

    );
}

export default SideBar